// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"db289d25","545":"0a18152a"}[chunkId] + ".chunk.css";
};